<template>
  <div class="document-preview">
    <Paginated :itemsPerPage="18" :fetch="fetchNextPage">
      <template #default="{ items, itemsTotal }">
	<strong style="line-height: 3.75rem">{{ itemsTotal }} {{$t('Pages')}}</strong>
  <p class="control">
      <b-tooltip position="is-bottom" :label="$t('Download')">
        <b-button @click="showModal" size="is-medium" icon-left="download" />
      </b-tooltip>
    </p>
	<ul class="document-preview-list">
	  <li
	    v-for="item in items"
	    :key="item.number"
	    class="document-preview-item"
	  >
	    <slot v-bind="item"></slot>
	  </li>
	</ul>
      </template>
    </Paginated>
  </div>
</template>

<style>
 .document-preview {
   min-height: 240px;
 }

 .document-preview-list {
   display: flex;
   flex-flow: row wrap;
   margin: 1.25rem 0;
   padding: 1.25rem 0 0 1.25rem;
   background-color: rgba(0, 0, 0, 0.025);
 }

 .document-preview-item {
   margin: 0 1.25rem 0.75rem 0;
 }

 .document-preview-loader {
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
 }
</style>

<script>
 import Paginated from '@/components/Paginated.vue'
 import DocumentDownload from "@/components/DocumentDownloadModal.vue";


 export default {
   components: { Paginated, DocumentDownload },
   props: {
     id: {
       type: Number,
       required: true
     }
   },
   data() {
     return {
       total: null,
       isReady: false
     }
   },
   methods: {
     async fetchNextPage({ offset, limit }) {
       const data = await this.api.fetchDocumentPages(this.id, { offset, limit })
       this.total = data.total
       this.isReady = true
       return data
     },
     showModal() {
      this.$buefy.modal.open({
        parent: this,
        component: DocumentDownload,
        canCancel: true,
        props: {
          docId: this.id,
          total: this.total     
        },
      });
    },
   }
 }
</script>
